window.Branch = window.Branch || {};
window.Branch.productGallery = window.Branch.productGallery || {};
window.Branch.productGallery.variantsViewed = [];
window.Branch.productGallery._firstFeaturedVariantDisplayingOnStandInInitialized = false;
window.Branch.productGallery.loadedImages = {};


// Reusable function to autoplay videos in gallery slides
window.Branch.productGallery.autoplayVideo = function(slideElement) {
  if (!slideElement || !slideElement.classList.contains('is-video')) {
    return;
  }

  const videoContainer = slideElement.querySelector('.main-product-gallery__video-container');
  if (!videoContainer) {
    return;
  }

  const video = videoContainer.querySelector('video');
  const playButton = videoContainer.querySelector('.custom-video-play');

  if (video) {
    // Video already exists, just play it
    setTimeout(() => {
      if (video.ended) {
        video.currentTime = 0;
      }
      const poster = videoContainer.querySelector('.deferred-media__poster');
      if (poster) {
        $(poster).fadeOut(100);
      }
      const attemptPlay = (retriesLeft) => {
        const p = video.play();
        if (p && typeof p.then === 'function') {
          p.catch((err) => {
            if (err && err.name === 'AbortError' && retriesLeft > 0 && video.paused) {
              setTimeout(() => attemptPlay(retriesLeft - 1), 200);
            }
          });
        }
      };
      attemptPlay(2);
    }, 250);
  } else if (playButton) {
    // No video yet, click the play button to load and play
    setTimeout(() => {
      playButton.click();
    }, 250);
  }
};

// Reusable function to initialize video controls for any gallery
window.Branch.productGallery.initializeGalleryVideos = function(containerSelector) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // Initialize any existing videos in the gallery
  const existingVideos = container.querySelectorAll('video');
  existingVideos.forEach(video => {
    const videoContainer = video.closest('.main-product-gallery__video-container');
    const playButton = videoContainer ? videoContainer.querySelector('.custom-video-play') : null;
    window.Branch.productGallery.setupVideoEventHandlers(video, playButton);
  });

  if (container.dataset.galleryVideoClickListenerBound === 'true') return;
  container.dataset.galleryVideoClickListenerBound = 'true';

  // Delegate click events for both play buttons and videos
  container.addEventListener('click', function(e) {
    // Handle play button clicks
    const playButton = e.target.closest('.custom-video-play');
    if (playButton) {
      e.preventDefault();
      e.stopPropagation();

      window.Branch.productGallery.handlePlayButtonClick(playButton);
      return;
    }

    // Handle video clicks (for pause/play toggle)
    const video = e.target.closest('video');
    if (video) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.Branch.productGallery.handleVideoClick(video);
      return;
    }
  });
};

// Handle play button click
window.Branch.productGallery.handlePlayButtonClick = function(playButton) {
  const videoContainer = playButton.closest('.main-product-gallery__video-container');
  if (!videoContainer) return;

  // Check if video already exists
  let video = videoContainer.querySelector('video');

  if (!video) {
    // Create video element if it doesn't exist
    const template = videoContainer.querySelector('template');
    if (template) {
      // Clone template content and insert it
      const content = template.content.cloneNode(true);
      videoContainer.appendChild(content);
      video = videoContainer.querySelector('video');

      // Set up new video element
      if (video) {
        window.Branch.productGallery.setupVideoEventHandlers(video, playButton);
      }
    }
  }

  if (video) {
    // Hide poster image when playing
    const poster = videoContainer.querySelector('.deferred-media__poster');
    if (poster) {
      $(poster).fadeOut(100);
    }

    // Play the video
    if (video.paused) {
      video.play();
      playButton.style.display = 'none';
    } else {
      video.pause();
      playButton.style.display = 'block';
    }
  }
};

// Handle video click (pause/play toggle)
window.Branch.productGallery.handleVideoClick = function(video) {
  const videoContainer = video.closest('.main-product-gallery__video-container');
  const playButton = videoContainer ? videoContainer.querySelector('.custom-video-play') : null;

  if (video.paused) {
    video.play();
    if (playButton) playButton.style.display = 'none';
  } else {
    video.pause();
    if (playButton && !video.ended) {
      playButton.style.display = 'block';
    }
  }
};

// Set up video event handlers
window.Branch.productGallery.setupVideoEventHandlers = function(video, playButton) {
  // Avoid duplicate event listeners
  if (video.hasAttribute('data-events-initialized')) return;
  video.setAttribute('data-events-initialized', 'true');

  video.addEventListener('play', function() {
    if (playButton) playButton.style.display = 'none';
  });

  video.addEventListener('pause', function() {
    if (playButton && !video.ended) {
      playButton.style.display = 'block';
    }
  });

  video.addEventListener('ended', function() {
    if (playButton) playButton.style.display = 'block';
  });
};

// Initialize quick-view gallery videos
window.Branch.productGallery.initializeQuickViewVideos = function() {
  window.Branch.productGallery.initializeGalleryVideos('.main-product__item[data-quick-view="true"]');
};

window.Branch.productGallery.initializeQuickViewProductGallery = function(){

  // Swiper lazy-load guard
  if (typeof window.Swiper === 'undefined') {
    if (typeof window.whenSwiperReady === 'function') {
      window.whenSwiperReady(function(){ window.Branch.productGallery.initializeQuickViewProductGallery(); });
    }
    return;
  }

  const container = document.querySelector('.main-product__item[data-quick-view="true"] .main-product-gallery__outer-container');

  if (!container) {
    console.warn('Quick view product gallery container not found');
    return;
  }

  // Clear loaded images cache for this product when reinitializing
  const qvGalleryEl = container.closest('.main-product-gallery');
  const qvProductId = qvGalleryEl ? qvGalleryEl.getAttribute('data-product-id') : 'default';
  window.Branch.productGallery.loadedImages[qvProductId] = new Set();

  // Initialize lazy loading for quick view gallery images
  window.Branch.productGallery.initializeLazyLoading(true);

  // Initialize video click handlers for quick-view
  window.Branch.productGallery.initializeQuickViewVideos();

  // Destroy existing quick view swiper if it exists
  if (window.Branch.productGallery.quickViewGallerySwiper) {
    try {
      window.Branch.productGallery.quickViewGallerySwiper.destroy(true, true);
      window.Branch.productGallery.quickViewGallerySwiper = null;
    } catch (error) {
      console.error('Error destroying existing quick view swiper:', error);
    }
  }

  // Initialize quick view swiper with simplified configuration
  const swiperParams = {
    slidesPerView: 1,
    spaceBetween: 0,
    // Add dots pagination
    pagination: {
      el: '.main-product__item[data-quick-view="true"] .swiper-pagination',
      clickable: true,
      type: 'bullets'
    },
    // Optional navigation arrows (if you want them)
    navigation: {
      nextEl: '.main-product__item[data-quick-view="true"] .main-product-gallery__special-direction-icon[data-direction="right"]',
      prevEl: '.main-product__item[data-quick-view="true"] .main-product-gallery__special-direction-icon[data-direction="left"]',
    },
    on: {
      init: function() {
        let activeSlides = document.querySelectorAll('.main-product__item[data-quick-view="true"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide.slideVisible');
        let activeSlidesCount = activeSlides && activeSlides.length > 0 ? activeSlides.length : 0;
        let actualIndex = this.slides.length - activeSlidesCount + this.activeIndex;

        // Set initial slide's data-actual-current-slide attribute
        if (this.slides[actualIndex]) {
          this.slides[actualIndex].setAttribute('data-actual-current-slide', 'true');
        }

        // Set data-number-of-slides attribute
        this.el.setAttribute('data-number-of-active-slides', activeSlides.length);

        // Set data-first-slide-displaying attribute on main-product-gallery element
        const isFirstSlide = this.activeIndex === 0;
        const galleryElement = this.el.closest('.main-product-gallery');
        if (galleryElement) {
          galleryElement.setAttribute('data-first-slide-displaying', isFirstSlide.toString());
        }

        // Auto-play video if first slide is a video in quick-view
        const currentItem = this.slides[actualIndex];
        window.Branch.productGallery.autoplayVideo(currentItem);
      },
      slideChange: function() {
        // Preload all product images on first slide change (only fires once per product, shared with swatch click)
        const qvProductItem = this.el.closest('.main-product__item');
        const qvProductId = qvProductItem ? qvProductItem.id.replace('main-product-item-', '') : null;
        if(qvProductId && window.Branch.product && window.Branch.product._products && window.Branch.product._products[qvProductId] && !window.Branch.product._preloadImagesFired[qvProductId]){
            window.Branch.product._preloadImagesFired[qvProductId] = true;
            let product = window.Branch.product._products[qvProductId];
            if(product.media && product.media.length > 0){
                let containerSelector = `.main-product .main-product__item#main-product-item-${product.id}`;
                window.Branch.product.preloadImages(product, 'click', 'main-product', containerSelector, true);
            }
        }

        let activeSlides = document.querySelectorAll('.main-product__item[data-quick-view="true"] .main-product-gallery__outer-container .main-product-gallery__item.swiper-slide.slideVisible');
        let activeSlidesCount = activeSlides && activeSlides.length > 0 ? activeSlides.length : 0;
        let actualIndex = this.slides.length - activeSlidesCount + this.activeIndex;

        // Remove data-actual-current-slide from all slides
        this.slides.forEach(slide => {
          slide.removeAttribute('data-actual-current-slide');
        });

        // Add data-actual-current-slide to the current slide
        if (this.slides[actualIndex]) {
          this.slides[actualIndex].setAttribute('data-actual-current-slide', 'true');
        }

        // Load the shown slide and its neighbours (initializeLazyLoading upgrades only the first few).
        [actualIndex, actualIndex + 1, actualIndex - 1].forEach((slideIndex) => {
          if (this.slides[slideIndex]) {
            window.Branch.productGallery.loadGalleryImage(this.slides[slideIndex]);
          }
        });

        // Update data-first-slide-displaying attribute on main-product-gallery element
        const isFirstSlide = this.activeIndex === 0;
        const galleryElement = this.el.closest('.main-product-gallery');
        if (galleryElement) {
          galleryElement.setAttribute('data-first-slide-displaying', isFirstSlide.toString());
        }

        // Pause videos if function exists
        if (typeof window.galleryVideoPause === 'function') {
          window.galleryVideoPause();
        }

        // Auto-play video on slide change for quick-view
        const currentItem = this.slides[actualIndex];
        window.Branch.productGallery.autoplayVideo(currentItem);
      }
    }
  };

  // Check if pagination container exists, if not create it
  let paginationEl = container.parentElement.querySelector('.swiper-pagination');
  if (!paginationEl) {
    paginationEl = document.createElement('div');
    paginationEl.classList.add('swiper-pagination');
    container.parentElement.appendChild(paginationEl);
  }

  // Create the quick view swiper instance
  window.Branch.productGallery.quickViewGallerySwiper = new Swiper(container, swiperParams);
}

// The groups the UGC slides sit in front of, matched against the handleized values in
// data-user-groups — handles, not labels, so 'assembly' rather than 'Assembly'. A handle matches
// exactly or as a prefix on a segment boundary, so 'assembly' also catches 'assembly-steps'. The
// first one present in the gallery wins.
window.Branch.productGallery.ugcSlideAnchorGroups = ['assembly'];

// Function to sort visible gallery items by user group
window.Branch.productGallery.sortVisibleGalleryItemsByUserGroup = function(isQuickView){
  const galleryContainer = document.querySelector(`.main-product__item[data-quick-view="${isQuickView}"] .main-product-gallery__inner-container`);
  if (galleryContainer) {
    const visibleItems = Array.from(galleryContainer.querySelectorAll(`.main-product-gallery__item.slideVisible`));

    // Collect all unique user groups from visible items (same as in updateForUserGroups)
    const userGroupsSet = new Set();
    visibleItems.forEach(item => {
      const userGroupsAttr = item.getAttribute('data-user-groups');
      if (userGroupsAttr) {
        // Remove leading/trailing underscores and split by comma
        const groups = userGroupsAttr.replace(/^_|_$/g, '').split(',');
        groups.forEach(group => {
          const trimmedGroup = group.trim();
          if (trimmedGroup) {
            userGroupsSet.add(trimmedGroup);
          }
        });
      }
    });

    // Convert to array and ensure default is first (then remove it since we don't sort by default)
    let userGroupsArray = Array.from(userGroupsSet);

    // Remove 'default' from the array if present since we'll handle those separately.
    userGroupsArray = userGroupsArray.filter(group => group !== 'default');

    /*
      'ugc' is then positioned rather than left where the Set happened to find it, moving to sit
      immediately ahead of the anchor group. The append order below IS the gallery's DOM order, and
      everything downstream follows from it: the thumbnail rail clones slides in DOM order, and
      updateForUserGroups() walks them in DOM order to build the filter buttons. So this is the one
      place that decides where "Styled By You" lands, in the gallery and the rail and the tabs.

      With no anchor group on the product, 'ugc' comes out of the list altogether. That sends the
      UGC slides into itemsWithoutGroup, which is appended last and sorted by data-index — and UGC
      indexes continue past the product media, so they land at the very end of the gallery rather
      than ahead of the plain default images. That was the behaviour for every product before the
      anchor existed, and it stays the fallback.
    */
    const anchorGroups = window.Branch.productGallery.ugcSlideAnchorGroups || [];
    const ugcPosition = userGroupsArray.indexOf('ugc');

    if (ugcPosition > -1) {
      userGroupsArray.splice(ugcPosition, 1);

      const anchorPosition = userGroupsArray.findIndex((group) => {
        const handle = group.toLowerCase();
        return anchorGroups.some((anchorGroup) => {
          return handle === anchorGroup || handle.indexOf(anchorGroup + '-') === 0;
        });
      });

      if (anchorPosition > -1) {
        userGroupsArray.splice(anchorPosition, 0, 'ugc');
      }
    }

    // Create a map to store items by their primary user group
    const itemsByGroup = new Map();
    const itemsWithoutGroup = [];

    // Initialize map for each user group
    userGroupsArray.forEach(group => {
      itemsByGroup.set(group, []);
    });

    // Categorize items by their first non-default user group
    visibleItems.forEach(item => {
      const userGroupsAttr = item.getAttribute('data-user-groups');
      if (userGroupsAttr) {
        const groups = userGroupsAttr.replace(/^_|_$/g, '').split(',').map(g => g.trim());

        // Find the first non-default group for this item
        let assigned = false;
        for (const group of userGroupsArray) {
          if (groups.includes(group)) {
            itemsByGroup.get(group).push(item);
            assigned = true;
            break; // Assign to first matching group only
          }
        }

        // If no non-default group found or only has default, add to items without group
        if (!assigned) {
          itemsWithoutGroup.push(item);
        }
      } else {
        // Items without any user groups
        itemsWithoutGroup.push(item);
      }
    });

    // Sort items within each group by data-index
    const sortByIndex = (items) => {
      return items.sort((a, b) => {
        const aIndex = parseInt(a.getAttribute('data-index')) || 0;
        const bIndex = parseInt(b.getAttribute('data-index')) || 0;
        return aIndex - bIndex;
      });
    };

    // Re-append items in the desired order
    // First append items by user group order
    userGroupsArray.forEach(group => {
      const items = itemsByGroup.get(group);
      if (items && items.length > 0) {
        sortByIndex(items).forEach(item => {
          galleryContainer.appendChild(item);
        });
      }
    });

    // Finally append items without a category (or only default)
    if (itemsWithoutGroup.length > 0) {
      sortByIndex(itemsWithoutGroup).forEach(item => {
        galleryContainer.appendChild(item);
      });
    }
  }
}

window.Branch.productGallery.sortGalleryItemsByIndex = function(isQuickView, visibleItemsOnly){
  const galleryContainer = document.querySelector(`.main-product__item[data-quick-view="${isQuickView}"] .main-product-gallery__inner-container`);
  if (galleryContainer) {
    const items = Array.from(galleryContainer.querySelectorAll(`.main-product-gallery__item${visibleItemsOnly ? '.slideVisible' : ''}`));

    // Sort by data-index attribute
    items.sort((a, b) => {
      const aIndex = parseInt(a.getAttribute('data-index')) || 0;
      const bIndex = parseInt(b.getAttribute('data-index')) || 0;
      return aIndex - bIndex;
    });

    // Re-append in sorted order
    items.forEach(item => {
      galleryContainer.appendChild(item);
    });
  }
}

window.Branch.productGallery.setMainImageLoadingBackground = function(isQuickView, fromVariantChange, selectedItemIndex){
  console.log('setMainImageLoadingBackground')
  let quickView = isQuickView ? 'true' : 'false';
  let overlay = document.querySelector(`.main-product__item[data-quick-view="${quickView}"] .main-product-gallery__thumbnails-loading-overlay .main-product-gallery__thumbnails-loading-overlay-inner-inner`);
  if(!overlay) return;
  overlay.innerHTML = '';

  let sourceContainer = document.querySelector(`.main-product__item[data-quick-view="${quickView}"] .main-product-gallery__outer-container .main-product-gallery__item[data-actual-current-slide="true"] .main-product-gallery__image-inner-container`);
  if(!sourceContainer) return;
  overlay.appendChild(sourceContainer.cloneNode(true));

  if(fromVariantChange == false || window.Branch.productGallery._firstFeaturedVariantDisplayingOnStandInInitialized == false){
    window.Branch.productGallery._firstFeaturedVariantDisplayingOnStandInInitialized = true;
    let overlayInner = overlay.closest('.main-product-gallery__thumbnails-loading-overlay-inner');
      if(overlayInner){
        let featuredImageDisplaying = selectedItemIndex == 0;
        overlayInner.setAttribute('data-featured-image-was-displaying', featuredImageDisplaying);
      }
  }
}

// Lazy loading functionality for gallery images
window.Branch.productGallery.loadGalleryImage = function(slideElement, origin) {
  if (!slideElement) return;

  const index = slideElement.getAttribute('data-index');
  const galleryEl = slideElement.closest('.main-product-gallery');
  const productId = galleryEl ? galleryEl.getAttribute('data-product-id') : 'default';
  if (!window.Branch.productGallery.loadedImages[productId]) {
    window.Branch.productGallery.loadedImages[productId] = new Set();
  }
  // Dedupe per physical slide element, NOT per data-index: many slides share the same data-index
  // (it repeats across user-group / variant-matched copies — e.g. index "8" appears 4×), so an
  // index-keyed Set skipped every slide after the first of each duplicated index, leaving them on
  // the 90px placeholder (blurry). A per-element flag upgrades each slide exactly once.
  // Zoom clones copy the flag from their slide but still need the zoom background below.
  if (slideElement.getAttribute('data-lazy-loaded') === 'true' && origin !== 'dimensions-overlay-switch' && origin !== 'zoom') {
    return; // Already loaded
  }

  const bgImage = slideElement.querySelector('.main-product-gallery__bg-image img');
  const mainImages = slideElement.querySelectorAll('.main-product__main-product-image');

  // Load background image with higher quality
  if (bgImage && bgImage.hasAttribute('data-lazy-src')) {
    const lazySrc = bgImage.getAttribute('data-lazy-src');
    bgImage.setAttribute('src', lazySrc);
    bgImage.removeAttribute('data-lazy-src');
  }

  // Load main image with higher quality
  mainImages.forEach((mainImage) => {
    if (mainImage && mainImage.hasAttribute('data-lazy-srcset')) {
      const lazySrcset = mainImage.getAttribute('data-lazy-srcset');
      const lazySrc = mainImage.getAttribute('data-lazy-src');

      if (lazySrc) mainImage.setAttribute('src', lazySrc);
      if (lazySrcset) mainImage.setAttribute('srcset', lazySrcset);

      mainImage.removeAttribute('data-lazy-src');
      mainImage.removeAttribute('data-lazy-srcset');
    }
  })

  // The 1800px zoom image is only shown by the zoom overlay, which clones the slides and loads
  // each clone with origin 'zoom'. Set on a gallery slide, it was painted behind the main image
  // (about 13 MB decoded each on a phone) and copied into every thumbnail clone.
  const innerContainer = slideElement.querySelector('.main-product-gallery__image-inner-container');
  if (origin === 'zoom' && innerContainer && innerContainer.hasAttribute('data-lazy-bg')) {
    const lazyBg = innerContainer.getAttribute('data-lazy-bg');

    if (window.Branch.productGallery.selectedDimensionsOverlayStatus == "on") {
      const dimensionsOverlayImg = slideElement.querySelector('.main-product__dimensions-overlay-image');
      if (dimensionsOverlayImg) {
        let overlaySrc = dimensionsOverlayImg.getAttribute('src');
        if (overlaySrc) {
          overlaySrc = overlaySrc.includes('?') ? overlaySrc + '&width=1800' : overlaySrc + '?width=1800';
          innerContainer.style.backgroundImage = `url(${overlaySrc}), url(${lazyBg})`;
        } else {
          innerContainer.style.backgroundImage = `url(${lazyBg})`;
        }
      } else {
        innerContainer.style.backgroundImage = `url(${lazyBg})`;
      }
    } else {
      innerContainer.style.backgroundImage = `url(${lazyBg})`;
    }

    // innerContainer.removeAttribute('data-lazy-bg');
  }

  window.Branch.productGallery.loadedImages[productId].add(index);
  slideElement.setAttribute('data-lazy-loaded', 'true');
};

// Initialize lazy loading for visible slides
window.Branch.productGallery.initializeLazyLoading = function(isQuickView) {
  let quickViewSelector = isQuickView ? 'true' : 'false';

  // Upgrade only the slides seen first: the first three of the selected variant, plus the hero
  // and the variant's current slide. The gallery swiper's slideChange loads the current slide
  // and its neighbours, the zoom overlay loads its own clones, and the thumbnails take their
  // 360px images from data-lazy-srcset. Upgrading every slide of the variant (42 on Erg Pro)
  // on each load and each color change pushed the page's memory peak up on phones.
  const visibleSlides = Array.from(document.querySelectorAll(`.main-product__item[data-quick-view="${quickViewSelector}"] .main-product-gallery__item.slideVisible`));
  const firstSlides = new Set(visibleSlides.slice(0, 3));
  visibleSlides.forEach(slide => {
    if (slide.getAttribute('data-first-image-atf') === 'true' || slide.getAttribute('data-actual-current-slide') === 'true') {
      firstSlides.add(slide);
    }
  });
  firstSlides.forEach(slide => {
    window.Branch.productGallery.loadGalleryImage(slide);
  });

  // Set up intersection observer for loading images as they come into view
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.Branch.productGallery.loadGalleryImage(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '100px' // Start loading 100px before the image comes into view
    });

    // Observe all non-visible slides
    const allSlides = document.querySelectorAll(`.main-product__item[data-quick-view="${quickViewSelector}"] .main-product-gallery__item:not(.slideVisible)`);
    allSlides.forEach(slide => {
      imageObserver.observe(slide);
    });
  }
};